<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tit01">
<h2 class="titlePageTitle"><span class="bold">CONFEDERATE GOLD</span></h2>
<h2 class="titlePageAuthor"><span class="bold">CAMERON JUDD</span></h2>
<p class="titlePagePublisher"><img alt="image" src="Images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312943349_tit01.vue?af5ba304